export default __webpack_public_path__ + "static/media/BC_188_BC_R9008.e91a9d55.jpg";